"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @private
 */
exports.DIRECTUS_ENDPOINTS = {
    getCountries: '{{customBaseHost}}/items/countries',
    getCities: '{{customBaseHost}}/items/cities',
    getArticles: '{{customBaseHost}}/items/articles',
    getHowItWorksArticles: '{{customBaseHost}}/items/how_it_works',
    getContactInformations: '{{customBaseHost}}/items/contact',
    getAboutUsArticles: '{{customBaseHost}}/items/about_us',
};
